/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wie eine neue Zeile entsteht (Betreiber 16.09.2026):
 * 
 *   AUTOMATISCH — sobald in der letzten Zeile etwas steht, erscheint die
 *                 naechste. Kein Knopf.
 *   KNOPF       — eine neue Zeile entsteht erst auf Knopfdruck.
 * @export
 */
export const DatabaseEingabelisteHinzufuegen = {
    Automatisch: 'AUTOMATISCH',
    Knopf: 'KNOPF'
} as const;
export type DatabaseEingabelisteHinzufuegen = typeof DatabaseEingabelisteHinzufuegen[keyof typeof DatabaseEingabelisteHinzufuegen];


export function DatabaseEingabelisteHinzufuegenFromJSON(json: any): DatabaseEingabelisteHinzufuegen {
    return DatabaseEingabelisteHinzufuegenFromJSONTyped(json, false);
}

export function DatabaseEingabelisteHinzufuegenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEingabelisteHinzufuegen {
    return json as DatabaseEingabelisteHinzufuegen;
}

export function DatabaseEingabelisteHinzufuegenToJSON(value?: DatabaseEingabelisteHinzufuegen | null): any {
    return value as any;
}

